






















































import {Vue, Component} from 'vue-property-decorator';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import DateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
import DateFilterBtns from '@/components/board/common/PageDateFilterBtns.vue';
import {FilterDataType, AllFilterDateMapping} from '@/types/product';
import {toI18n, getCurrency} from '@/utils/commonUtils';
import {changeDateFormat, momentAdd} from '@/utils/dateUtils';
import {DisplayEnum} from '@/types/enum';

@Component({
  components: {
    PageFormSelect,
    DateRangePicker,
    DateFilterBtns
  }
})
export default class ModifyImmediateDiscount extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }
  private hasError = false;
  private errorMsg = '';
  private today: string = changeDateFormat('', 'YYYY-MM-DD');
  private currentDiscountUnitType = 'AMOUNT';
  private immediateDiscountValue = '0';
  private discountPeriodYn = false;
  private initRangeStartYmd = this.today;

  private get discountPeriodYnDisabled(): boolean {
    const value = this.immediateDiscountValue + '';
    const result = value === '' || value === '0';
    if (result) {
      this.discountPeriodYn = false;
      this.windowSizeChange();
    }
    return result;
  }

  private get maxlength(): number {
    return this.currentDiscountUnitType === 'AMOUNT' ? 11 : 2;
  }

  private get mallProductNos(): string[] {
    return this.$route.params.mallProductNos.split(',');
  }

  private get startYmdt(): string {
    return `${this.dateReceiveData.startYmd} ${this.timeReceiveData.startTime}:00`;
  }

  private get endYmdt(): string {
    return `${this.dateReceiveData.endYmd} ${this.timeReceiveData.endTime}:00`;
  }

  private get currentDateRange(): string {
    const selectVal: FilterDataType = this.filterDateData.find((data: FilterDataType): any => data.selected) || {
      value: '0',
      label: toI18n('BOARD_FAQ_TODAY'),
      selected: true
    };
    return selectVal.value;
  }

  private immediateDiscountValueInput() {
    let value = this.immediateDiscountValue;
    value = value.replace(/[^0-9]/gi, '');
    this.immediateDiscountValue = value === '' ? '' : getCurrency(value);
  }

  private immediateDiscountUnitType: DisplayEnum[] = [
    {value: 'AMOUNT', label: this.toI18n('WON')}, //원
    {value: 'PERCENT', label: '%'}
  ];

  private filterDateData: FilterDataType[] = [
    {value: '3d', label: this.toI18n('DAYS_3'), selected: false}, //3일
    {value: '7d', label: this.toI18n('DAYS_7'), selected: false}, //7일
    {value: '15d', label: this.toI18n('DAYS_15'), selected: false}, //15일
    {value: '30d', label: this.toI18n('DAYS_30'), selected: false}, //30일
    {value: '60d', label: this.toI18n('DAYS_60'), selected: false}, //60일
    {value: '90d', label: this.toI18n('DAYS_90'), selected: false} //90일
  ];

  private filterDateMapping: AllFilterDateMapping = {
    '3d': [3, 'd'],
    '7d': [7, 'd'],
    '15d': [15, 'd'],
    '30d': [30, 'd'],
    '60d': [60, 'd'],
    '90d': [90, 'd']
  };

  private dateData: {startYmd: string; endYmd: string} = {
    startYmd: this.today,
    endYmd: momentAdd(this.today, this.filterDateMapping['90d'], 'YYYY-MM-DD')
  };

  private dateReceiveData = {...this.dateData};

  private timeData: {startTime: string; endTime: string} = {
    startTime: '00:00',
    endTime: '23:59'
  };
  private timeReceiveData = {...this.timeData};

  private setEndYmd(): void {
    this.dateData = {...this.dateReceiveData};
    Object.assign(this.dateData, {
      startYmd: this.dateReceiveData.startYmd,
      endYmd: momentAdd(this.dateReceiveData.startYmd, this.filterDateMapping[this.currentDateRange], 'YYYY-MM-DD')
    });
  }

  private setFilterUnSelected(): void {
    const oldIdx = this.filterDateData.findIndex((item: FilterDataType): any => item.selected);
    this.$set(this.filterDateData, oldIdx, {...this.filterDateData[oldIdx], selected: false});
  }

  private dateFilterChange(idx: number): void {
    this.setFilterUnSelected();
    this.$set(this.filterDateData, idx, {...this.filterDateData[idx], selected: true});
    this.setEndYmd();
  }

  private dateDataChange({startYmd, endYmd, isBtnSet}: any): void {
    if (!isBtnSet) {
      this.setFilterUnSelected();
    }
    this.dateReceiveData = {startYmd, endYmd};
  }

  private timeDataChange({startTime, endTime}: any): void {
    this.timeReceiveData = {startTime, endTime};
  }

  private onChangeDiscountUnitType() {
    this.immediateDiscountValue = '0';
  }

  private windowSizeChange() {
    let width = 1300;
    let height = 560;

    if (!this.discountPeriodYn) {
      width = 680;
      height = 300;
    }
    $('.content').css({width, height});
    window.resizeTo(width + 40, height + 50);
  }

  private priceCheck() {
    this.hasError = false;
    if (this.immediateDiscountValue !== '' && this.immediateDiscountValue !== '0') {
      const price = this.immediateDiscountValue.replace(/,/gi, '');
      const lastNumber = price.charAt(price.length - 1);

      if (this.currentDiscountUnitType === 'AMOUNT' && lastNumber !== '0') {
        this.errorMsg = this.toI18n('THE_PRICE_IN_UNITS_OF_10_WON'); //가격은 10원 단위로 입력 가능합니다.
        this.hasError = true;
      } else if (this.currentDiscountUnitType === 'AMOUNT' && Number(price) > 999999999) {
        this.errorMsg = this.toI18n('THE_PRICE_FOR_LESS_THAN_1_BILLION_WON'); //가격은 10억원 미만으로 입력 가능합니다.
        this.hasError = true;
      }
    }
  }

  private dateFormat(Ymdt: any): {date: string; time: string} {
    if (Ymdt) {
      return {
        date: Ymdt.substring(0, 10),
        time: Ymdt.substring(11, 16)
      };
    }
    return {date: '', time: ''};
  }

  private save() {
    if (this.immediateDiscountValue === '') {
      alert(this.toI18n('PLEASE_ENTER_A_VALUE')); //값을 입력해주세요
      return;
    }
    const immediateDiscountInfo = {
      unitType: this.currentDiscountUnitType,
      startYmdt: this.discountPeriodYn ? this.startYmdt : '',
      amount: Number(this.immediateDiscountValue.replace(/,/gi, '')),
      endYmdt: this.discountPeriodYn ? this.endYmdt : '',
      periodYn: this.discountPeriodYn ? 'Y' : 'N'
    };

    const params = {
      mallProductNos: String(this.mallProductNos)
    };

    this.$api.patchProducts({params, data: {immediateDiscountInfo}}).then(({data}: any): void => {
      if (data.failures && data.failures.length) {
        if(data.failures[0].errorCode === 'INVALID_IMMEDIATE_DISCOUNT_AMOUNT_RANGE') {
          return alert('해당 즉시할인금액으로 변경 불가한 상품이 포함되어 있습니다.\n즉시할인금액은 마이너스 옵션가가 적용된 판매가 이하로만 설정 가능합니다.')
        }
        return alert(data.failures[0].message);
      }
      window.opener.postMessage({immediateDiscount: true, data});
      this.close();
    });
  }

  private close() {
    window.close();
  }

  private created() {
    document.body.classList.add('popup');
    // window.moveBy(-1000, 0);

    if (this.mallProductNos.length === 1) {
      const params = {
        mallProductNo: Number(this.mallProductNos[0])
      };
      this.$api.getProductByNo({params}).then(
        ({
          data: {
            immediateDiscountInfo: {amount, endYmdt, periodYn, startYmdt, unitType}
          }
        }: any) => {
          this.immediateDiscountValue = amount + '';
          this.immediateDiscountValueInput();
          this.currentDiscountUnitType = unitType;
          periodYn === 'Y' ? (this.discountPeriodYn = true) : (this.discountPeriodYn = false);
          if (this.discountPeriodYn) {
            const {date: endYmd, time: endTime} = this.dateFormat(endYmdt);
            const {date: startYmd, time: startTime} = this.dateFormat(startYmdt);

            this.initRangeStartYmd = startYmd;
            Object.assign(this.dateData, {
              startYmd,
              endYmd
            });
            Object.assign(this.timeData, {
              startTime,
              endTime
            });
          }
        }
      );
    } else {
      this.immediateDiscountValue = '';
    }

    window.name = 'immediateDiscount';
  }
}
